/** Vida Cloud app id for Surf web (header `X-Vida-AppId`). */
export const SURF_APP_ID = "surf";
